// extracted by mini-css-extract-plugin
module.exports = {"page-background":"_3L3Me","pageBackground":"_3L3Me"};